import { RoutesService } from './../../../shared/services/routes/route.service';
import { catchError, take } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  viewChild,
  effect
} from '@angular/core';
import { StandService } from 'app/stand/stand.service';
import { CompanyProductsGQL, CompanyProductsResponse } from '@shared/services/products/graphql/company-products.gql.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QueryRef } from 'apollo-angular';
import { UserRolesEnum } from '@collections/users/enums';
import { StandLayoutEnum } from '../../stand.enums';
import { ProductBlockModule } from '@products/views/product-block/product-block.module';
import { PagedVirtualScrollerModule } from '@shared/components/paged-virtual-scroller/paged-virtual-scroller.module';
import { RobotsIndexEnum } from 'app/shared/services/meta-data-service/meta-data.commons';
import { EMPTY, EmptyError } from 'rxjs';
import { PageScrollerInfo, PagedVirtualScrollerComponent } from 'app/shared/components/paged-virtual-scroller/paged-virtual-scroller.component';
import { ICompany } from '@collections/companies/interfaces';
import { IProduct } from '@collections/products/interfaces';

@UntilDestroy()
@Component({
  selector: 'stand-products',
  standalone: true,
  imports: [
    ProductBlockModule,
    PagedVirtualScrollerModule
  ],
  providers: [
    CompanyProductsGQL
  ],
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsComponent implements OnInit {

  @Input()
  urlPrefix = './';
  @Input() mode: 'page' | 'component' = 'page';
  @Input() scaleUpOnRender = true;
  @Input() itemListId: string;
  @Input() itemListName: string;


  productsQuery: QueryRef<CompanyProductsResponse>;
  UserRolesEnum = UserRolesEnum;
  showEditBar = false;
  virtualScroller = viewChild(PagedVirtualScrollerComponent);
  company: ICompany;

  constructor(
    private standService: StandService,
    private companyProductsGQL: CompanyProductsGQL,
    private platform: Platform,
    private routesService: RoutesService
  ) {
    if (this.mode === 'page') {
      let init = false;
      effect(() => {
        const products: IProduct[] = this.virtualScroller().items();
        if(!init && products) {
            try {
              init = true;
              if (this.mode === 'page') {
                const canonical = {...this.standService.canonicalDefaultUrl};
                canonical.path = canonical.path.indexOf('?after') > -1 ? canonical.path : canonical.path + '/products';
    
          
                const carousel = products.map((p) => this.routesService.getProductUrl(this.company, p.slug));
                this.standService.appendCompanyMetaTags(canonical, carousel, RobotsIndexEnum.noindex_follow);
              }

              if (this.platform.isBrowser) {
                //  tracking page on analytics browser
                this.itemListId = 'stans_products_list';
                this.itemListName = this.company.slug + '_products_list';
              }
            }
            catch(err) {
              console.log(err);
            }
          }
      }, {allowSignalWrites: true});
    }
      
  }

  ngOnInit(): void {
    this.standService.getCurrentCompany()
      .pipe(untilDestroyed(this))
      .subscribe(company => {
        this.company = company;
        this.productsQuery = this.companyProductsGQL.watch({
          companyId: company._id,
          lang: this.standService.currentLanguageCode,
          first: 16,
        });
        // const canonical = {...this.standService.canonicalDefaultUrl};
        // canonical.path = canonical.path.indexOf('?after') > -1 ? canonical.path : canonical.path + '/products';
        // if (!this.platform.isBrowser) {
        //   this.productsQuery.valueChanges
        //   .pipe(
        //     take(1),
        //     catchError((err) => {
        //       return EMPTY;
        //     })
        //   )
        //   .subscribe(({data: {productsByCompany: {edges}}}) => {
        //     const carousel = edges.map((e) => this.routesService.getProductUrl(company, e.node.slug));
        //     this.standService.appendCompanyMetaTags(canonical, carousel, RobotsIndexEnum.noindex_follow);
        //   })
        // }

        // if (this.platform.isBrowser && this.mode === 'page') {
        //   this.itemListId = 'stans_products_list';
        //   this.itemListName = company.slug + '_products_list';
        // //  tracking page on analytics browser side and metadata server-side

        // this.standService.appendCompanyMetaTags(canonical, null, RobotsIndexEnum.noindex_follow);
        // }

      });
  }

}
